export default __webpack_public_path__ + "static/media/Gaz.745f2ce9.svg";